import React from "react"
import styles from "./not-found.module.scss"

const NotFound = () => {
 return <div className={styles.element}>NotFound</div>
}

export default NotFound